(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-money-cross-sell"] && !Shopify.designMode) return;
  try {
    if (!window.mmMoneyCartInstalled) {
 window.mmMoneyCartInstalled = true;
 let busy = false;
 const root = window.Shopify?.routes?.root || '/';
 const dismissed = new Set();
 document.addEventListener('click', (e) => {
  const button = e.target.closest('.sm-decline');
  if (!button) return;
  const card = button.closest('[data-sm-companion]');
  dismissed.add(card.dataset.smCompanion); card.hidden = true;
 });
 new MutationObserver(() => document.querySelectorAll('[data-sm-companion]').forEach(card => {
  if (dismissed.has(card.dataset.smCompanion)) card.hidden = true;
 })).observe(document.body, {childList:true, subtree:true});
 document.addEventListener('change', (e) => {
  if (!e.target.matches('.sm-cart-form select[name="id"]')) return;
  const chosen = e.target.selectedOptions[0];
  const price = e.target.closest('.sm-purchase')?.querySelector('[data-sm-price]');
  if (price) price.textContent = chosen.dataset.price;
 });
 document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.sm-cart-form');
  if (!form) return;
  e.preventDefault();e.stopImmediatePropagation();
  if (busy) return;
  busy = true;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[role="status"]');
  button.disabled = true;
  try {
   const id = Number(new FormData(form).get('id'));
   if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Invalid variant');
   const cartResponse = await fetch(root+'cart.js', {headers:{Accept:'application/json'}});
   if (!cartResponse.ok) throw new Error('Cart unavailable');
   const cart = await cartResponse.json();
   if (!cart.items.some(item => item.variant_id === id)) {
    const added = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
    if (!added.ok) { const error = await added.json();throw new Error(error.description || 'Could not add item'); }
   }
   window.location.assign(root+'cart');
  } catch (error) {
   status.textContent = error.message;
   button.disabled = false;busy = false;
  }
 }, true);
}
  } catch(e) { console.error(e); }
})();

})();
